import React from 'react';
import DataTable from '../reporting_utils/DataTable';

const $ = window.$;

/**
 * @param {{
 *   tableData: Array;
 *   isAutomotiveIndustry: boolean;
 *   prospectCallTypes: string[];
 *   industryType: string;
 * }} props
 */
export default function SourceBreakdownTable({
  tableData,
  isAutomotiveIndustry,
  prospectCallTypes,
  industryType,
}) {
  function buildColumns() {
    /** @type {import('../reporting_utils/DataTable').ColumnDef[]} */
    const columns = [];
    columns.push({ data: 'adsource', title: 'Source' });
    if (industryType !== 'Call Center') {
      columns.push({ data: 'ref_medium', title: 'Referral' });
    }
    columns.push({
      title: 'Prospects',
      children: prospectCallTypes.map((callType) => {
        return {
          data: callType.replace(/[^a-z]/gi, '_').toLowerCase(),
          render: $.fn.dataTable.render.number(','),
          title: callType,
          aggregation: 'sum',
        };
      }),
    });
    columns.push({
      data: 'non_prospects',
      render: $.fn.dataTable.render.number(','),
      title: isAutomotiveIndustry ? 'Non-Prospects' : 'Non-Leads',
      aggregation: 'sum',
    });
    columns.push({
      data: 'undetermined',
      render: $.fn.dataTable.render.number(','),
      title: 'Undetermined',
      aggregation: 'sum',
    });
    columns.push({
      data: 'total_calls',
      render: $.fn.dataTable.render.number(','),
      title: 'Total Calls',
      aggregation: 'sum',
    });
    return columns;
  }

  return (
    <div className='row row_top_buffer'>
      <div className='col-xs-12'>
        <div className='report_data_container'>
          <div className='title'>Source Call Type</div>
          <DataTable
            columnDefs={buildColumns()}
            data={tableData}
            title='Source Call Type'
            showTotalFooter={true}
            order={[[2, 'desc']]}
          />
        </div>
      </div>
    </div>
  );
}
